import logo from "./logo.svg";
import "./App.css";
import Iangel from "./pages/iangel";
import AllRoutes from "./components/AllRoutes";

function App() {
  return (
    <div className="App">
        <AllRoutes />
    </div>
  );
}

export default App;
